<template>
  <div class="ReceiptWrap">
    <van-nav-bar
      :title="$t('platform.receiptSet')"
      left-arrow
      fixed
      z-index="9"
      @click-left="$router.push('/ShopSet/' + sessionStorage.actShopId)"
    >
      <van-icon
        name="./static/img/ok.png"
        slot="right"
        @click="submit()"
        style="font-size: 24px"
      />
    </van-nav-bar>
    <div class="bg_white ninew bodybox">
      <div class="mlr">
        <van-row class="">
          <van-col span="6"></van-col>
          <van-col span="6">{{ $t("ShopSet.is_show") }}</van-col>
          <van-col span="6">{{ $t("ShopSet.is_write") }}</van-col>
          <van-col span="6">{{ $t("ShopSet.is_print") }}</van-col>
        </van-row>
        <van-row v-for="(v, k) in deliveryList" :key="k" class="tenTop">
          <van-col span="6">
            <span v-if="v.type == 1">{{ $t("ShopSet.take_name") }}</span>
            <span v-if="v.type == 2">{{ $t("ShopSet.take_tel") }}</span>
            <span v-if="v.type == 3">{{ $t("ShopSet.take_address") }}</span>
            <span v-if="v.type == 4">{{ $t("ShopSet.PickUpDate") }}</span>
            <span v-if="v.type == 5">{{ $t("ShopSet.PickUpTime") }}</span>
            <span v-if="v.type == 6">{{ $t("ShopSet.deliveryDate") }}</span>
            <span v-if="v.type == 7">{{ $t("ShopSet.deliveryTime") }}</span>
            <span v-if="v.type == 8">{{ $t("ShopSet.comment") }}</span>
          </van-col>
          <van-col span="6">
            <van-switch
              v-model="v.is_show"
              active-color="#2f75f7"
              inactive-color="#ee0a24"
            />
          </van-col>
          <van-col span="6">
            <van-switch
              v-model="v.is_write"
              active-color="#2f75f7"
              inactive-color="#ee0a24"
            />
          </van-col>
          <van-col span="6">
            <van-switch
              v-model="v.is_prints"
              active-color="#2f75f7"
              inactive-color="#ee0a24"
            />
          </van-col>
        </van-row>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      deliveryList: [],
    };
  },
  mounted() {
    this.getDelivery();
  },
  methods: {
    getDelivery() {
      this.$axios({
        method: "get",
        headers: {
          Authorization: "Bearer " + sessionStorage.token,
        },
        url:
          this.$build + "/api/delivery/" + sessionStorage.actShopId + "/index",
      })
        .then((res) => {
          console.log("delivery>:>>>>>>>>>");
          console.log(res.data);
          if (res.data.status == 200) {
            res.data.data.forEach((d) => {
              if (d.is_prints == 1) {
                d.is_prints = true;
              } else {
                d.is_prints = false;
              }
              if (d.is_show == 1) {
                d.is_show = true;
              } else {
                d.is_show = false;
              }
              if (d.is_write == 1) {
                d.is_write = true;
              } else {
                d.is_write = false;
              }
            });

            this.deliveryList = res.data.data;
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item],
              });
            }
          }
        })
        .catch((err) => {
          this.$toast({
            type: "fail",
            message: this.$t("EditShop.message"),
          });
        });
    },
    submit() {
      this.deliveryList.forEach((d) => {
        var ajaxData = {
          is_show: d.is_show,
          is_write: d.is_write,
          is_prints: d.is_prints,
        };
        this.$axios({
          method: "PATCH",
          headers: {
            Authorization: "Bearer " + sessionStorage.token,
          },
          url: this.$build + "/api/delivery/" + d.id + "/update",
          data: ajaxData,
        })
          .then((res) => {
            console.log(res);
            if (res.data.status == 200) {
              this.$toast({
                type: "success",
                message: res.data.message,
              });
              const vm = this;
              setTimeout(function () {
                vm.$router.push("/ShopSet/" + sessionStorage.actShopId);
              }, 1000);
            } else {
              this.$toast.allowMultiple();
              for (var item in res.data.error) {
                this.$toast({
                  type: "fail",
                  message: res.data.error[item],
                });
              }
            }
          })
          .catch((err) => {
            this.$toast({
              type: "fail",
              message: this.$t("EditShop.message"),
            });
          });
      });
    },
  },
};
</script>
<style scoped>
/deep/ .van-nav-bar .van-icon {
  font-size: 24px;
  color: #fff;
}
/deep/ .van-nav-bar__left {
  padding: 0;
  left: -4px;
}
/deep/ .van-nav-bar__right {
  padding: 0;
}
.text {
  margin-top: 20px;
  font-size: 18px;
  text-align: center;
}
.mlr {
  margin: 0 14px;
  padding: 10px 0;
}
.bg_black {
  background: black;
}
.bg_white {
  background: white;
}

.text_white {
  color: white;
}

.text_black {
  color: #636363;
}
.ninew {
  width: 95%;
  margin: 0 auto;
}

.text-center {
  text-align: center;
}
.sixTop {
  margin-top: 6px;
}

.tenTop {
  margin-top: 10px;
}

.fifTop {
  margin-top: 15px;
}
</style>



// WEBPACK FOOTER //
// src/Shop/ReceiptInfoSet.vue